import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';
import ForgotPasswordPage from './ForgotPasswordPage';
import ResetPasswordPage from './ResetPasswordPage';
import AppLayout from './AppLayout';
import Profile from './Profile';
import ChangeEmailPage from './ChangeEmailPage';
import ReauthenticatePage from './ReauthenticatePage';
import NewPasswordPage from './NewPasswordPage';
import ProtectedRoute from './ProtectedRoute';
import DeleteAccountConfirmPage from './DeleteAccountConfirmPage';
import { AuthProvider } from './AuthContext';
import { ScreenBuilderProvider } from './ScreenBuilderContext';
import AppHomeRedirect from './AppHomeRedirect';
import HomePage from './components/chat/HomePage.js';
import WatchlistEditor from './components/watchlist/WatchlistEditor.js';
import ScreenBuilder from './components/screens/ScreenBuilder.js';
import BacktestsViewer from './components/backtests/BacktestsViewer.js';
import BacktestConfigsPage from './components/backtestConfigs/BacktestConfigsPage.js';
import ScreenResultsViewer from './components/screenResults/ScreenResultsViewer.js';
import SharedResultsPage from './components/share/SharedResultsPage.js';
import SeasonalityPage from './components/seasonality/SeasonalityPage.js';
import ChartPage from './components/chart/ChartPage.js';
import './App.css';  // Make sure to use the updated App.css

function App() {
  return (
    <AuthProvider>
      <ScreenBuilderProvider>
        <Router>
        <Routes>
          <Route path="/" element={<AppHomeRedirect />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/share/:shareId" element={<SharedResultsPage />} />
          
          <Route path="/dashboard" element={<AppLayout />}>
            <Route index element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
            <Route path="strategies" element={<ProtectedRoute><ScreenBuilder /></ProtectedRoute>} />
            <Route path="screens" element={<ProtectedRoute><ScreenBuilder /></ProtectedRoute>} />
            <Route path="backtest-configs" element={<ProtectedRoute><BacktestConfigsPage /></ProtectedRoute>} />
            <Route path="watchlists" element={<ProtectedRoute><WatchlistEditor /></ProtectedRoute>} />
            <Route path="screen-results" element={<ProtectedRoute><ScreenResultsViewer /></ProtectedRoute>} />
            <Route path="backtest-results" element={<ProtectedRoute><BacktestsViewer /></ProtectedRoute>} />
            <Route path="backtests" element={<ProtectedRoute><BacktestsViewer /></ProtectedRoute>} />
            <Route path="optimizer-results" element={<ProtectedRoute><BacktestsViewer mode="optimization" /></ProtectedRoute>} />
            <Route path="seasonality" element={<ProtectedRoute><SeasonalityPage /></ProtectedRoute>} />
            <Route path="charts" element={<ProtectedRoute><ChartPage /></ProtectedRoute>} />
            <Route path="profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="reauthenticate" element={<ProtectedRoute><ReauthenticatePage /></ProtectedRoute>} />
            <Route path="new-password" element={<ProtectedRoute><NewPasswordPage /></ProtectedRoute>} />
            <Route path="change-email" element={<ProtectedRoute><ChangeEmailPage /></ProtectedRoute>} />
            <Route path="delete-account-confirm" element={<ProtectedRoute><DeleteAccountConfirmPage /></ProtectedRoute>} />
          </Route>
        </Routes>
        </Router>
      </ScreenBuilderProvider>
    </AuthProvider>
  );
}

export default App;
